/** @format */

import {Box, ButtonBase, Typography} from '@mui/material';
import {alpha, styled} from '@mui/material/styles';

const PREFIX = 'ProjectCard';

export const ProjectCardClasses = {
  root: `${PREFIX}-root`,
  bodyError: `${PREFIX}-bodyError`,
  bodyErrorText: `${PREFIX}-bodyErrorText`,
};

// Root card surface — forwards ref so useCardBody's IntersectionObserver can observe it.
export const ProjectCardRoot = styled(Box)(({theme}) => {
  // Hover tint: surface-2 mixed in at 30% over the surface-1 card background. A translucent
  // backgroundColor would blend with the page behind the card, not its own surface-1 — so layer
  // the 30% surface-2 as a flat gradient on top of the background instead.
  const hoverOverlay = alpha(theme.palette.semantic_dark?.surface.surface2 ?? '#4A4B4F', 0.3);

  return {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4), // 16px between header / status row / body
    backgroundColor: theme.palette.semantic_dark?.surface.surface1,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4), // 16px
    cursor: 'pointer',
    '&:hover': {
      backgroundImage: `linear-gradient(${hoverOverlay}, ${hoverOverlay})`,
    },
  };
});

// Inline error state for the lazy body
export const BodyErrorWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  minHeight: 200,
  padding: theme.spacing(4),
}));

export const BodyErrorText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  fontSize: 14,
  lineHeight: '20px',
}));

export const RetryButton = styled(ButtonBase)(({theme}) => ({
  color: theme.palette.semantic_dark?.primary.main,
  fontSize: 14,
  lineHeight: '20px',
  padding: theme.spacing(1, 2),
  borderRadius: 4,
  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.primary.container,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.semantic_dark?.primary.main}`,
    outlineOffset: 2,
  },
}));
